"use strict";import{SideNavItem as e}from"./src/SidenavItem.js";import{defineElement as m}from"@spectrum-web-components/base/src/define-element.js";m("sp-sidenav-item",e);
//# sourceMappingURL=sp-sidenav-item.js.map
